var map = {
	"./404.png": "3dfc",
	"./AA-purple@2x.png": "2907",
	"./BoCM_Small_White@2x.png": "e5bd",
	"./EN.png": "f5ba",
	"./FR.png": "e2ab",
	"./MBoC_Small_White@2x.png": "bb9d",
	"./analyse-black@2x.png": "0a5b",
	"./analyse-color@2x.png": "756c",
	"./analyse_icon.png": "06ff",
	"./close_gris.png": "a296",
	"./exchange-black@2x.png": "9222",
	"./exchange-color@2x.png": "d9db",
	"./exchange/Agriculture.png": "93cf",
	"./exchange/Energy.png": "c9bd",
	"./exchange/Manufactured.png": "290e",
	"./exchange/Metal.png": "066c",
	"./exchange/Nonenergy.png": "3c29",
	"./exchange/Vehicles.png": "6eab",
	"./exchange/Wood.png": "2d9d",
	"./exchange_icon.png": "e894",
	"./flag-ca.png": "16d1",
	"./flags/AT.png": "2fa6",
	"./flags/AU.png": "15e0",
	"./flags/BE.png": "4cab",
	"./flags/BR.png": "7080",
	"./flags/CA.png": "f7ef",
	"./flags/CH.png": "ce3e",
	"./flags/CL.png": "abec",
	"./flags/CN.png": "6d54",
	"./flags/DE.png": "004b",
	"./flags/DK.png": "c602",
	"./flags/FR.png": "cd47",
	"./flags/HK.png": "dac9",
	"./flags/ID.png": "6389",
	"./flags/IE.png": "78c2",
	"./flags/IN.png": "75cc",
	"./flags/IT.png": "1479",
	"./flags/JP.png": "0390",
	"./flags/MX.png": "d60d",
	"./flags/NL.png": "62cd",
	"./flags/NO.png": "b7b9",
	"./flags/RU.png": "65b1",
	"./flags/SA.png": "9793",
	"./flags/SE.png": "54b4",
	"./flags/SG.png": "6087",
	"./flags/UK.png": "f389",
	"./flags/US.png": "0613",
	"./icon_calendrier@2x.png": "1b2b",
	"./immigration-black@2x.png": "2e67",
	"./immigration-color@2x.png": "5e06",
	"./immigration/ANZ.png": "17b5",
	"./immigration/AS.png": "1c6e",
	"./immigration/CAMC.png": "1ccc",
	"./immigration/CE.png": "9a0e",
	"./immigration/MENA.png": "54dd",
	"./immigration/SSA.png": "b065",
	"./immigration/UKC-1867.png": "0105",
	"./immigration/UKC-1896.png": "abae",
	"./immigration/UKC-1916.png": "df26",
	"./immigration/UKC-1932.png": "315f",
	"./immigration/UKC-1941.png": "323e",
	"./immigration/UKC-1968.png": "c101",
	"./immigration/UKC-1989.png": "a7b6",
	"./immigration/UKC-2009.png": "df2a",
	"./immigration/US.png": "3abc",
	"./immigration_icon.png": "2a12",
	"./pib-black@2x.png": "1533",
	"./pib_icon.png": "6e79",
	"./piggybank.png": "b7c8",
	"./poppyflower@2x.png": "cb22",
	"./scroll.png": "a941",
	"./setting-purple@2x.png": "4dcd",
	"./setting-white.png": "5b63",
	"./small-PIB.jpg": "dc7f",
	"./small-analyse.jpg": "51a9",
	"./small-exchange.jpg": "7260",
	"./small-immigration.jpg": "6971",
	"./u29.png": "09af",
	"./u54.png": "6bff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";